import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { InlineWarningBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineWarningBanner/InlineWarningBanner'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { SessionLimitInfo } from './hooks/useSessionLimitInfo'

export interface SessionLimitWarningsProps extends SessionLimitInfo {
  testIDPrefix: string
  section: 'warning' | 'limitInfo'
}

export const SessionLimitWarnings: FunctionComponent<SessionLimitWarningsProps> = ({
  showLowSessionsWarning,
  showHealthPlanLimitInfo,
  lowSessionsRemainingText,
  healthPlanLimitInfoText,
  testIDPrefix,
  section,
}) => {
  const { colors } = useTheme()

  if (section === 'warning') {
    return showLowSessionsWarning ? (
      <InlineWarningBanner
        text={<BodyText text={lowSessionsRemainingText} size={BodyTextSize.DEFAULT} color={colors.textWarning} />}
        testId={tID(`${testIDPrefix}-LowSessionsRemainingWarning`)}
      />
    ) : null
  }

  return showHealthPlanLimitInfo ? (
    <BodyText testID={tID(`${testIDPrefix}-HealthPlanLimitInfo`)} text={healthPlanLimitInfoText} />
  ) : null
}
